<template>
  <select
    class="v-datatable-light-items-per-page"
    @change="onUpdate"
    :disabled="disablePagination"
  >
    <option
      v-for="item in listItemsPerPage"
      :key="item"
      :value="item"
      :selected="itemsPerPage === item"
    >
      {{ item }}
    </option>
  </select>
</template>
<script>
export default {
  name: 'ItemsPerPageDropdown',
  props: {
    listItemsPerPage: {
      type: Array,
      default: () => [10, 30, 50]
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    css: {
      type: Object,
      default: () => ({
        select: ''
      })
    }
  },
  methods: {
    onUpdate: function (event) {
      this.$emit('onUpdate', event.target.value)
    }
  }

}
</script>
<style scoped src="./custom-grid.css"></style>
